<template lang="pug">
  v-dialog(v-model='dialog', max-width='750' persistent)
    v-card
      v-toolbar.elevation-0(color="gray")
        v-toolbar-title {{ $t('pageHeader.ipAddressList') }}
        v-spacer
        v-btn(icon @click="$emit('close')")
          v-icon close
      v-card-text
        v-data-table(:headers='headers',
          :items='list',
          :loading='loading',
          :search="search",
          :pagination.sync='pagination')
          template(slot='items', slot-scope='props')
            tr
              td.text-xs-left.pointer {{ props.item.ip }}
              td.text-xs-left.pointer {{ $moment(props.item.createdAt).format('MM/DD/YYYY') }}
              td.text-xs-left.pointer {{ $moment(props.item.updatedAt).format('MM/DD/YYYY') }}
          v-alert(slot='no-results', :value='true', color='error', icon='warning')
            | Your search for "{{ search }}" found no results.
</template>

<script>
import globalService from '../service.js'
export default {
  name: 'ip-address-list',
  props: {
    ipAddressDialog: {
      type: Boolean,
      default: false,
    },
    storeID: {
      default: 0
    }
  },
  data() {
    return {
      list: [],
      dialog: false,
      search: null,
      loading: true,
      pagination: {
        rowsPerPage: 10,
        sortBy: "updatedAt",
        descending: true
      },
      headers: [
        {
          text: this.$t("labels.ipAddress"),
          sortable: true,
          value: "CSPID"
        },
        {
          text: this.$t("labels.firstUsed"),
          value: "businessName",
          sortable: true
        },
        {
          text: this.$t("labels.lastUsed"),
          value: "businessPhone",
          sortable: true
        },
      ],
    }
  },
  watch:{
    ipAddressDialog(val) {
      this.dialog = val
      if(val) {
        return globalService.getIpAddress(this.storeID)
        .then(result => {
          this.list = result.data
          this.loading = false
        })
      }
    }
  },
}
</script>

<style scoped>
</style>